import { useQueryGetBookingById } from '@flecto/core/saas'
import { type ParameterID } from '@flecto/types'

export type UseBookingPublicLinkOptions = {
  bookingId?: ParameterID
}

export function useBookingPublicLink({
  bookingId,
}: UseBookingPublicLinkOptions) {
  const { data, isLoading, isSuccess } = useQueryGetBookingById({ bookingId })
  const host = process.env['FLECTO_LINK_URL'] ?? 'https://flec.to'
  const permalink = data?.permalink ?? ''
  const url = `${host}/${permalink}`

  return { url, isLoading, isSuccess }
}
